.header_QuoteAndBuy_f00e2e7{grid-template-columns:1fr 9fr 1fr}